import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Artikl, Opi, PdfInput, ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-kretanje-cijena-pdf',
  templateUrl: './kretanje-cijena-pdf.component.html',
  styleUrls: ['./kretanje-cijena-pdf.component.scss']
})
export class KretanjeCijenaPdfComponent {
  // Form
  filterForm!: FormGroup;
  loading = false;

  // Data
  artikli: Artikl[] = [];
  opisi: Opi[] = [];
  selectedArtikl: Artikl | null = null;
  selectedOpisi: number[] = [];

  // Selected items for PDF generation
  pdfInputs: PdfInput[] = [];

  // Add this to your component
  drzavaOptions = [
    { value: 'BiH', text: 'Bosna i Hercegovina' },
    { value: 'Hrv', text: 'Hrvatska' },
    { value: 'Srb', text: 'Srbija' },
    { value: 'Ino', text: 'Inostranstvo' }
  ];

  constructor(
    private apiClient: ApiClientService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  async ngOnInit() {
    await this.loadLookupData();
  }

  initializeForm() {
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);

    this.filterForm = this.fb.group({
      drzava: ['BiH', Validators.required],
      dateFrom: [oneMonthAgo, Validators.required],
      dateTo: [today, Validators.required],
      artikal: [null, Validators.required]
    });
  }

  async loadLookupData() {
    try {
      const [artikliData, opisiData] = await Promise.all([
        this.apiClient.artikliAll(),
        this.apiClient.opisiAll()
      ]);
      this.artikli = artikliData;
      this.opisi = opisiData;
    } catch (error) {
      console.error('Error loading lookup data:', error);
    }
  }

  onArtiklChange(event: any) {
    const artiklId = event.value;
    this.selectedArtikl = this.artikli.find(a => a.id === artiklId) || null;
    this.selectedOpisi = []; // Reset selected opisi when artikl changes
  }

  onOpisChange(event: any) {
    this.selectedOpisi = event.value || [];
  }

  addToPdfList() {
    const formData = this.filterForm.value;

    if (!formData.artikal) {
      alert('Odaberite artikl prvo!');
      return;
    }

    // Create proper PdfInput instance
    const pdfInput = new PdfInput();
    pdfInput.artikl = formData.artikal;
    pdfInput.opisi = [...this.selectedOpisi];

    // Check if this artikl is already in the list
    const existingIndex = this.pdfInputs.findIndex(input => input.artikl === formData.artikal);

    if (existingIndex > -1) {
      // Update existing entry
      this.pdfInputs[existingIndex] = pdfInput;
    } else {
      // Add new entry
      this.pdfInputs.push(pdfInput);
    }

    // Reset selection
    this.selectedOpisi = [];
  }

  removeFromPdfList(index: number) {
    this.pdfInputs.splice(index, 1);
  }

  getArtiklName(artiklId: number): string {
    const artikl = this.artikli.find(a => a.id === artiklId);
    return artikl ? artikl.artikl1 as string : `Artikl #${artiklId}`;
  }

  getOpisNames(opisiIds: number[]): string {
    if (!opisiIds || opisiIds.length === 0) return 'SVE';

    const opisNames = opisiIds.map(id => {
      const opis = this.opisi.find(o => o.id === id);
      return opis ? opis.opis : `Opis #${id}`;
    });

    return opisNames.join(', ');
  }

  async generatePdf() {
    if (this.filterForm.valid && this.pdfInputs.length > 0) {
      this.loading = true;
      try {
        const formData = this.filterForm.value;

        const response = await this.apiClient.generatePdf(
          formData.drzava,
          formData.dateFrom,
          formData.dateTo,
          this.pdfInputs
        );

        // Create download link
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `PriceMovement_${formData.drzava}_${formData.dateFrom.toISOString().split('T')[0]}_${formData.dateTo.toISOString().split('T')[0]}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error('Error generating PDF:', error);
        alert('Došlo je do greške prilikom generisanja PDF-a.');
      } finally {
        this.loading = false;
      }
    } else {
      if (this.pdfInputs.length === 0) {
        alert('Dodajte barem jedan artikl u listu za PDF generisanje!');
      }
    }
  }

  clearList() {
    this.pdfInputs = [];
    this.selectedOpisi = [];
  }
}
